import type {
  AdditionalInfoLineModel,
  AdditionalInfoTypeModel,
  PatchAdditionalInfoLineRequest,
  PostAdditionalInfoLineRequest,
} from '@/types/ForestOwners/AdditionalInfo'
import { apiDelete, apiGet, apiPatch, apiPost } from '../ApiClient'

export async function getAdditionalInfoLines(
  forestOwnerId: string,
): Promise<AdditionalInfoLineModel[]> {
  return apiGet<AdditionalInfoLineModel[]>(
    `/forestowners/${encodeURIComponent(forestOwnerId)}/additional-info`,
  )
}

export async function getAdditionalInfoTypes(): Promise<AdditionalInfoTypeModel[]> {
  return apiGet<AdditionalInfoTypeModel[]>('/forestowners/additional-info/types')
}

export async function addAdditionalInfoLine(
  forestOwnerId: string,
  command: PostAdditionalInfoLineRequest,
): Promise<{ id: string }> {
  return apiPost<{ id: string }>(
    `/forestowners/${encodeURIComponent(forestOwnerId)}/additional-info`,
    command,
  )
}

export async function updateAdditionalInfoLine(
  forestOwnerId: string,
  lineId: string,
  command: PatchAdditionalInfoLineRequest,
  etag?: string | null,
): Promise<void> {
  await apiPatch(
    `/forestowners/${encodeURIComponent(forestOwnerId)}/additional-info/${encodeURIComponent(lineId)}`,
    command,
    { etag },
  )
}

export async function removeAdditionalInfoLine(
  forestOwnerId: string,
  lineId: string,
  etag?: string | null,
): Promise<void> {
  await apiDelete(
    `/forestowners/${encodeURIComponent(forestOwnerId)}/additional-info/${encodeURIComponent(lineId)}`,
    {
      headers: etag ? { 'If-Match': etag } : undefined,
    },
  )
}
